// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZMt-","left":"styles_left__1aNFx"};